<div
  [style.display]="hidden ? 'none' : 'flex'"
  class="option"
  [class.selected]="selected"
  [class.highlighted]="highlighted"
  [class.disabled]="disabled"
  [class.error]="error"
  [class.multiple]="multiple"
  [class.dropdown-option]="dropdown"
  [class.default]="default"
  [ngClass]="['option-' + size]"
  (click)="onClick($event)"
>
  <ds-checkbox
    *ngIf="multiple"
    [checked]="selected"
    (change)="onClick($event)"
    [error]="error"
    [disabled]="disabled"
  ></ds-checkbox>
  <span class="option-label" [class.wrap]="wrap"><ng-content></ng-content></span>
</div>
